import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	blockTitle: '',
	blockDesc: '',
	blockContent: {
		left: {
			gap: 'gap24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'Екип от специалисти',
					text: 'Ние говорим твоя език. Екипът ни от хостинг експерти е това, което ни отличава. Приемаме успеха на бизнеса ти като наша кауза и се грижим за него, дори отвъд задълженията ни. Попитай за нас и ще се увериш!',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		right: {
			gap: 'gap-8-12', // classname from css file (block.scss) for space between items
			content: [
				{
					title: '4,97 / 5,00',
					subtitle: 'максимална оценка от нашите клиенти',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '24 часа / 7 дни',
					subtitle: 'денонощна поддръжка',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '200 000 уебсайта',
					subtitle: 'над 200 000 уебсайта ни се доверяват',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '100% увереност',
					subtitle: 'експертна помощ по всяко време',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		noteData: []
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockTitle: '',
	blockDesc: '',
	blockContent: {
		left: {
			gap: 'gap24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'Team of Experts',
					text: 'We speak your language. Our team of hosting experts is what sets us apart. We treat your business success as our mission and take care of it beyond our obligations. Ask around about us and see for yourself!'
				}
			]
		},
		right: {
			gap: 'gap-8-12', // classname from css file (block.scss) for space between items
			content: [
				{
					title: '4.97 / 5.00',
					subtitle: 'maximum customer rating',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '24 / 7',
					subtitle: 'around-the-clock support',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '200 000 websites',
					subtitle: 'over 200 000 websites trust us',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '100% confidence',
					subtitle: 'expert support at any time',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		noteData: []
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];